import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTMOB_Games_available } from './AvailableCount.messages.json';
import styles from './AvailableCount.scss';

interface AvailableCountProps {
  count: number;
}

const AvailableCount: React.FC<AvailableCountProps> = ({ count }) => (
  <div className={styles.availableCountContainer}>
    <Translation {...TXTMOB_Games_available} />
    &nbsp;
    <span>{count}</span>
  </div>
);

export default AvailableCount;
